module.exports = __webpack_public_path__ + "img/table.629b1e9f.png";